import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { FromNoDDL } from "../../../../../CommonDDL/FromNoDDL"



export const SiteVisit = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()


    return (
        <div className="row p-1 m-1 mt-2 ">

            <div className="col-12 col-lg-12" >
                <div className="row bg-white rounded_eic my-2" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>


                    <div className="col-12">
                        <div className="row mt-3">
                            {/* Received Complaints */}
                            <div className="col-12 col-lg-2">
                                <span className="text-dark  py-3 all_heading_fontsize">{t('EncroachmentDashboard.SiteVisit')}</span>

                            </div>

                            <div className="col-12 col-lg-2">
                                <FromNoDDL />
                            </div>

                            <div className="col-12 col-lg-8 text-end pb-2 mb-2 mt-2 mt-lg-0">
                                <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                    <input type="radio" className="btn-check" name="btnradio5" id="sky17" autocomplete="off" checked />
                                    <label className="btn btn-outline-primary fw-bold" for="sky17">{t('EncroachmentDashboard.Total')}</label>

                                    <input type="radio" className="btn-check" name="btnradio5" id="sky27" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky27">{t('EncroachmentDashboard.ZoneA')}</label>

                                    <input type="radio" className="btn-check" name="btnradio5" id="sky37" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky37 ">{t('EncroachmentDashboard.ZoneB')}</label>

                                    <input type="radio" className="btn-check" name="btnradio5" id="sky47" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky47">{t('EncroachmentDashboard.ZoneC')}</label>

                                    <input type="radio" className="btn-check" name="btnradio5" id="sky57" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky57">{t('EncroachmentDashboard.ZoneD')}</label>

                                    <input type="radio" className="btn-check" name="btnradio5" id="sky67" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky67">{t('EncroachmentDashboard.ZoneE')}</label>

                                    <input type="radio" className="btn-check" name="btnradio5" id="sky77" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky77">{t('EncroachmentDashboard.ZoneF')}</label>

                                    <input type="radio" className="btn-check" name="btnradio5" id="sky87" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky87">{t('EncroachmentDashboard.ZoneG')}</label>

                                    <input type="radio" className="btn-check" name="btnradio5" id="sky97" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky97">{t('EncroachmentDashboard.ZoneH')}</label>
                                </div>
                            </div>

                        </div>

                    </div>


                    {/* Site Visit Complaints Received*/}
                    <div className="col-12 col-md-4 pb-3 cursor-pointer"
                        onClick={() => navigate('/SiteVisitComplaintsReceivedUpdateGrid')}
                    >
                        <div className="p-4 background_style eic_BlueColor  rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row">
                                <div className="col-9">
                                    <h6 className=" text-dark" style={{ fontSize: '15px' }}>{t('EncroachmentDashboard.SiteVisitComplaintsReceived')}</h6>
                                    <h2 className="pt-2 fw-bold text-danger">40</h2>
                                </div>
                                <div className="col-3 d-flex align-items-center justify-content-center ">
                                    <img src="./assets/img/eic_img/SiteVisits.png" style={{ width: '40px' }} alt="" srcset="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Site Visited omplaints */}
                    <div className="col-12 col-md-4 pb-3 cursor-pointer"
                        onClick={() => navigate('/SiteVisitIllegalGrid')}
                    >
                        <div className="p-4 background_style eic_Yellowcolor rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row">
                                <div className="col-9">
                                    <h6 className=" text-dark">{t('EncroachmentDashboard.SiteVisitedComplaints')}</h6>
                                    <h2 className="pt-2 fw-bold text-danger">30</h2>
                                </div>
                                <div className="col-3 d-flex align-items-center justify-content-center ">
                                    <img src="./assets/img/eic_img/Pending_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Notice Issue Complaints */}
                    <div className="col-12 col-md-4 pb-3 cursor-pointer"
                        onClick={() => navigate('/SiteVisitedComplaintsIllegalGrid')}
                    >
                        <div className="p-4 background_style eic_pinkcolor rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row">
                                <div className="col-9">
                                    <h6 className=" text-dark">{t('EncroachmentDashboard.NoticeIssueComplaints')}</h6>
                                    <h2 className="pt-2 fw-bold text-danger">30</h2>
                                </div>
                                <div className="col-3 d-flex align-items-center justify-content-center ">
                                    <img src="./assets/img/eic_img/Issue_Notice.png" style={{ width: '40px' }} alt="" srcset="" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}